import React from 'react';
import { ReactComponent as Airport } from '../../../../../../assets/icons/airport.svg';
import { ReactComponent as Subway } from '../../../../../../assets/icons/subway.svg';
import { ReactComponent as Train } from '../../../../../../assets/icons/train.svg';
import styles from './Transportation.module.scss';
import { TransportationLinks } from 'common/types/search';



const TransportationComponent: React.FC<TransportationLinks> = ({ transportationLinks, country }) => {
  // object of objects > array of objects
  const transportationArray = Object.values(transportationLinks);

  // filter 2 closest values
  const uniqueTypes: Set<string> = new Set();
  const filteredTransportations = transportationArray
    .filter((link) => {
      if (!uniqueTypes.has(link.type_name)) {
        uniqueTypes.add(link.type_name);
        return true;
      }
      return false;
    })
    .sort((a, b) => parseInt(a.distance_in_meters) - parseInt(b.distance_in_meters))
    .slice(0, 2);

  const showInMiles = ['United States', 'United Kingdom', 'Liberia', 'Myanmar'].includes(country);

  return (
    <div className={styles.container}>
      {filteredTransportations.length > 0 && (
        filteredTransportations.map((link) => (
          <div key={link.transportation_id} className={styles.content}>
            {link.type_name === 'Airport' ? <Airport/> : link.type_name === 'Underground Station' ? <Subway /> : <Train />}
            <span className={styles.name}>{link.name.includes('???') ? link.type_name : link.name}</span>
            {' '}
            <span className={styles.distance}>
              {showInMiles
                ? `${(parseInt(link.distance_in_meters) * 0.000621371).toFixed(1)} miles`
                : `${(parseInt(link.distance_in_meters) / 1000).toFixed(1)} km`}
            </span>
          </div>
        ))
      )}
    </div>
  );
};

export default TransportationComponent;
